// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"230264ff","455":"a0381fb4"}[chunkId] + ".chunk.js";
};